import script from "./NewsletterAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsletterAlert.vue?vue&type=script&lang=ts&setup=true"

import "./NewsletterAlert.vue?vue&type=style&index=0&id=1bde3a44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/streamgames-customer-portal/streamgames-customer-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bde3a44"]])

export default __exports__